import dayjs from "dayjs";
import "dayjs/locale/it";

dayjs.locale("it");

export function fmtDateTime(v) {
  if (!v) return "—";
  const d = dayjs(v);
  return d.isValid() ? d.format("DD/MM/YYYY HH:mm") : "—";
}

export function fmtDate(v) {
  if (!v) return "—";
  const d = dayjs(v);
  return d.isValid() ? d.format("DD/MM/YYYY") : "—";
}

export function fmtNum(v, digits = 2) {
  if (v == null || v === "") return "—";
  const n = Number(v);
  if (Number.isNaN(n)) return "—";
  return n.toLocaleString("it-IT", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function fmtChange(v, digits = 2) {
  if (v == null) return null;
  const n = Number(v);
  if (Number.isNaN(n)) return null;
  const sign = n > 0 ? "+" : n < 0 ? "" : "";
  return sign + n.toLocaleString("it-IT", { minimumFractionDigits: digits, maximumFractionDigits: Math.max(digits, 3) });
}

/**
 * Formatta una percentuale con segno. Accetta il valore in forma %
 * (es. 1.86 → "+1,86%"). Se v è null/NaN ritorna null.
 */
export function fmtPct(v, digits = 2) {
  if (v == null) return null;
  const n = Number(v);
  if (Number.isNaN(n)) return null;
  const sign = n > 0 ? "+" : n < 0 ? "" : "";
  return sign + n.toLocaleString("it-IT", { minimumFractionDigits: digits, maximumFractionDigits: digits }) + "%";
}

/**
 * Calcola la variazione percentuale a partire dal valore corrente e dal
 * delta assoluto (change_value). Se il delta o il prezzo precedente sono
 * nulli/zero ritorna null (nessun confronto possibile).
 */
export function computePct(value, change) {
  if (value == null || change == null) return null;
  const v = Number(value);
  const c = Number(change);
  if (!Number.isFinite(v) || !Number.isFinite(c)) return null;
  const prev = v - c;
  if (prev === 0) return null;
  return (c / prev) * 100;
}
